import { Col, Row, Tabs } from 'antd';
import styled from 'styled-components';

export const TabContainerStyled = styled(Row)`
  height: 100%;
`;

export const TabNavigationContainerStyled = styled(Col)`
  border-right: 1px #e9ecef solid;
  height: 100%;
  background: white;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  *::-webkit-scrollbar {
    display: none;
  }
  scrollbar-width: none;
`;

export const SingleNavTabContainerStyled = styled.div`
  cursor: pointer;
`;

export const TabContentContainerStyled = styled.div`
  height: 100%;
  & > * {
    height: 100%;
  }
  *::-webkit-scrollbar {
    display: none;
  }
  * {
    scrollbar-width: none;
  }
  &.custom-tabs-content {
    display: none;
  }

  &.custom-tabs-content-active {
    display: block;
  }
`;

export const TabContentOuterContainerStyled = styled(Col)`
  flex: 1;
  overflow-y: auto;
  height: 100%;
  scrollbar-width: none;
  &::-webkit-scrollbar {
    display: none;
  }
  *::-webkit-scrollbar {
    display: none;
  }
  * {
    scrollbar-width: none;
  }
`;

export const ProfileTabContainerStyled = styled.div<{ $displayMenu?: boolean; $mobileThreshold?: number }>`
  height: 100%;
  & .custom-tabs-nav-bar {
    width: 19%;
    ${({ $mobileThreshold, $displayMenu }) =>
      $mobileThreshold
        ? `@media screen and (max-width: ${$mobileThreshold}px) {
            position: absolute;
            top: 0;
            left: 0;
            width: 50%;
            transform: translateX(${$displayMenu ? '0' : '-100%'});
            transition: transform 0.25s ease-in-out;
            z-index: 16;
            min-width: 100%
          } `
        : ''}
  }
`;

export const DefaultTabStyled = styled(Tabs)`
  min-height: 100%;
  flex: 1;
  width: 100%;
  & .ant-tabs-content {
    height: 100%;
  }
  & .ant-tabs-nav {
    overflow: hidden;
  }
`;
